import React from 'react';
import { Fieldset, FormNumber } from '~/components/FormControl';
import { Form } from 'react-bootstrap';

function Fight() {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>Fight</Fieldset.Legend>
            <Form.Row>
                <FormNumber
                    name="strikeAdded"
                    sm={3}
                />
                <FormNumber
                    name="blockAdded"
                    sm={3}
                />
                <FormNumber
                    name="opponentDefenseDeducted"
                    sm={5}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default Fight;
